import React from 'react';
import { BrainIcon, FileTextIcon, HomeIcon, MessagesSquareIcon, ToyBrickIcon } from 'lucide-react';
import { bonuses } from '../data/content';
const icons = {
  documentation: FileTextIcon,
  scenarios: MessagesSquareIcon,
  caregiver: HomeIcon,
  pediatric: ToyBrickIcon,
  neuro: BrainIcon
};
export function Bonuses() {
  return <section className="bg-ivory py-11 sm:py-14" aria-labelledby="bonuses-title" data-id="element-26" data-mp="fsbsb5vvlv87">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-27" data-mp="1tlpraqaf3cg">
        <p className="text-center text-[10.5px] font-semibold uppercase tracking-[0.2em] text-gold sm:text-xs" data-id="element-28" data-mp="5vqmwjfy2i3u">
          And that&apos;s just the core system
        </p>
        <h2 id="bonuses-title" className="mt-2 text-center font-display text-[23px] font-semibold uppercase leading-tight tracking-tightish text-navy-deep sm:text-3xl" data-id="element-29" data-mp="3o3porp60vcr4">
          You&apos;ll also get 5 premium bonus resources
        </h2>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:mt-8 sm:gap-4 lg:grid-cols-3" data-id="element-30" data-mp="1r80aljy6q62o">
          {bonuses.map((bonus, index) => {
          const Icon = icons[bonus.icon];
          const isLast = index === bonuses.length - 1;
          return <article key={bonus.title} className={`flex h-full flex-col rounded-xl border border-navy/10 bg-ivory-light p-4 shadow-card sm:p-5 ${isLast ? 'col-span-2 lg:col-span-1' : ''}`} data-id="element-31" data-mp="3r6i7l10s1lal" data-mpi={index}>
                <div className="flex items-center gap-2" data-id="element-32" data-mp="2zhf1rgt8s2vu">
                  <Icon className="h-[18px] w-[18px] shrink-0 text-teal" aria-hidden="true" data-id="element-33" data-mp="2uhsoj7deymn1" />
                  <p className="text-[10.5px] font-semibold uppercase tracking-[0.16em] text-gold sm:text-xs" data-id="element-34" data-mp="38hbhuu1kftfa">
                    {bonus.number}
                  </p>
                </div>
                <h3 className="mt-2 text-[13px] font-semibold uppercase leading-tight tracking-[0.02em] text-navy-deep sm:text-sm" data-id="element-35" data-mp="np8buj9azfkb">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-[12.5px] leading-snug text-navy-soft sm:text-[13.5px]" data-id="element-36" data-mp="3cjfylch1gpix">
                  {bonus.detail}
                </p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}